import { useEffect, useMemo, useRef, useState } from "react";
import ArrowBottomIcon from "../../Icon-SVG/ArrowBottomIcon";
import CustomScrollbar from "../CustomScrollbar/CustomScrollbar";
import { useOnClickOutside } from "../../../utils/hook/useOnClickOutside";
import "./styles.scss";

const CustomSelect = ({
  id = null,
  data,
  width = "80px",
  height = "32px",
  color = "var(--dashboard-value-color)",
  setSelected,
  select,
  placeholder,
  disabled = false,
  defaultIndex = 0,
  onSelectItem = null,
}) => {
  const [showItems, setShowItems] = useState(false);
  const [selectedItem, setSelectedItem] = useState(select);

  const ref = useRef();

  useOnClickOutside(ref, () => setShowItems(false));

  const dropDown = () => {
    if (disabled) return;
    setShowItems(!showItems);
  };

  const memoizedData = useMemo(() => data, [data]);

  // The stored selection is restored when the data changes, not each time the
  // parent passes a new setSelected function: that re-ran the restore on every
  // render, racing the save below and flipping the selection back and forth.
  const setSelectedRef = useRef(setSelected);
  setSelectedRef.current = setSelected;

  useEffect(() => {
    if (!id || !memoizedData.length) return;

    const storedData = localStorage.getItem(`${id}LastSelected`);
    const parsedData = storedData && storedData !== "null" ? JSON.parse(storedData) : null;
    // Stored selection may no longer exist in the current data
    const storedItem = parsedData && memoizedData.find((item) => item.id === parsedData.id);
    const nextItem = storedItem || memoizedData[defaultIndex];

    if (JSON.stringify(select) !== JSON.stringify(nextItem)) {
      setSelectedRef.current(nextItem);
      setSelectedItem(nextItem);
    }
  }, [id, memoizedData, defaultIndex]);

  useEffect(() => {
    if (id && select) {
      localStorage.setItem(`${id}LastSelected`, JSON.stringify(select));
    }
    setSelectedItem(select);
  }, [select, id]);

  useEffect(() => {
    if (!select && !disabled && !id) {
      setSelected(memoizedData[defaultIndex]);
      setSelectedItem(memoizedData[defaultIndex]);
    }
  }, [memoizedData, setSelected, defaultIndex, id, select, disabled]);

  const selectItem = (item) => {
    if (onSelectItem) {
      onSelectItem(item);
    }
    setSelectedItem(item);
    setShowItems(false);
    setSelected(item);
  };

  return (
    <div className="select-box--box" style={{ width }} ref={ref}>
      <div
        className="select-box--container"
        onClick={dropDown}
        style={{
          width,
          color,
          height,
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
        }}>
        <div className="select-box--selected-item">
          {selectedItem?.value ? (
            selectedItem.value
          ) : (
            <span className="placeholder">{placeholder && placeholder}</span>
          )}
        </div>
        <div className="select-box--arrow">
          <ArrowBottomIcon width={14} height={14} />
        </div>
      </div>

      <div
        className="select-box--options"
        style={{
          display: showItems && !disabled ? "block" : "none",
          width,
        }}>
        {/* <CustomScrollbar maxHeight={100} className="border"> */}
        {data.map((item) => (
          <div
            key={item.id}
            onClick={() => selectItem(item)}
            className={`select ${selectedItem?.id === item.id ?"selected" : ""}`}>
            {item.value}
          </div>
        ))}
        {/* </CustomScrollbar> */}
      </div>
    </div>
  );
};

export default CustomSelect;
